import { Component, Input } from "@angular/core"
import { Router } from "@angular/router"

@Component({
	selector: "app-notification",
	templateUrl: "./notification.component.html",
	styleUrls: ["./notification.component.scss"]
})
export class NotificationComponent {
	@Input() item: any
	@Input() length: any
	@Input() status: any

	constructor(public router: Router) {}
}
